import styled, { css } from 'styled-components';
import {
  TTypographyColor,
  TTypographyFontFamily,
  TTypographyLineHeight,
  TTypographySize,
} from '@/components/atoms/Typography/Typography';
import Link from 'next/link';

export const CustomLink = styled(Link).withConfig({
  shouldForwardProp: (prop) =>
    !['size', 'lineHeight', 'fontFamily', 'as', 'color', 'hoverColor'].includes(
      prop
    ),
})<{
  size: TTypographySize;
  color: TTypographyColor;
  hoverColor: TTypographyColor;
  lineHeight: TTypographyLineHeight;
  fontFamily: TTypographyFontFamily;
}>`
  ${({ size }) => css`
    --link-fs: var(--fs-${size !== 'default' && size ? size : 'base'});
  `}

  ${({ color }) =>
    color !== 'default' &&
    css`
      --link-c: var(--c-font-${color});
    `}

  ${({ hoverColor }) =>
    hoverColor !== 'default' &&
    css`
      --link-c-hover: var(--c-font-${hoverColor}, var(--c-font-secondary));
    `}

  ${({ lineHeight }) =>
    lineHeight !== 'default' &&
    css`
      --link-lh: var(--lh-${lineHeight});
    `}

  ${({ fontFamily }) =>
    fontFamily !== 'default' &&
    css`
      --link-ff: var(--ff-${fontFamily});
    `}

  &:hover {
    color: var(--link-c-hover, var(--c-font-secondary));
  }

  position: relative;
  font-size: var(--link-fs, var(--fs-base));
  color: var(--link-c, var(--c-font-primary));
  line-height: var(--link-lh, var(--lh-base));
  font-family: var(--link-ff, var(--ff-helvetica-regular));
  text-decoration: none;
  padding: 0;
  margin: 0;
  transition: color 0.3s;
`;

export const ContainerLink = styled(Link).withConfig({
  shouldForwardProp: (prop) => !['imageHoverEffect'].includes(prop),
})<{
  imageHoverEffect: boolean;
}>`
  display: flex;
  align-items: center;
  overflow: hidden;

  ${({ imageHoverEffect }) =>
    imageHoverEffect &&
    css`
      &:hover img {
        transform: scale(1.02);
      }
    `}
`;

export const DisabledLink = styled.div`
  position: relative;
`